import React from 'react';
import PropTypes from 'prop-types';
import { Button } from '@els/els-react--button';

function ShowConditionsButton({ toggleAllDetails, showNextConditions, index }) {
  return (
    <span className="load-more-item">
      <Button
        data-e2e="show-conditions"
        data-testid="show-more-button"
        className="load-more-item e2e-show-conditions u-els-margin-1o2 u-els-margin-left-3o4 u-els-margin-right-3o4"
        type="tertiary"
        size="small"
        aria-controls={`reaction-details-${index}`}
        onClick={toggleAllDetails}>
        {showNextConditions}
      </Button>
    </span>
  );
}

ShowConditionsButton.propTypes = {
  toggleAllDetails: PropTypes.func.isRequired,
  showNextConditions: PropTypes.string.isRequired,
  index: PropTypes.string.isRequired,
};

export default ShowConditionsButton;
